import { render, staticRenderFns } from "./domainUpdate.vue?vue&type=template&id=498cef6c&"
import script from "./domainUpdate.vue?vue&type=script&lang=js&"
export * from "./domainUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports